module.exports = __webpack_public_path__ + "img/game5.13c9abd8.jpg";